<template>
  <v-app>
    <v-app-bar class="white elevation-2" clipped-left fixed app>
      <v-app-bar-nav-icon @click="drawer = !drawer" />
      <v-btn icon class="ml-2" @click="reload()">
        <v-icon x-large v-text="'mdi-cached'" class="blue--text" />
      </v-btn>
      <v-toolbar-title v-text="title" class="black--text p1-1" />
      <v-spacer />
      <v-toolbar-title v-text="$store.state.childPageTitle" class="font-weight-black" />
      <v-spacer />
      <AccountMenu />
    </v-app-bar>
    <v-navigation-drawer
      clipped
      app
      class="elevation-20 primary"
      v-model="drawer"
    >
      <v-list dense nav dark>
        <v-list-item
          class="pa-2 ma-2"
          v-for="(item, i) in items"
          :key="i"
          :to="item.to"
          router
          exact
          color="white"
          @click="drawer = !drawer"
        >
          <v-list-item-action>
            <v-icon large v-text="item.icon" />
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title v-text="item.title" class="subtitle-1" />
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-main class="min-width=90vw">
      <v-container class="mb-15 d-flex justify-center">
        <nuxt />
      </v-container>
      <v-container class="d-flex justify-center">
        <FooterLogo />
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import FooterLogo from '~/components/FooterLogo'
import AccountMenu from '~/components/AccountMenu'
import { isAdminRole, isTrialAdminRole } from '~/helper/RoleHelper'

export default {
  components: {
    FooterLogo,
    AccountMenu,
  },
  data: () => ({
    drawer: false,
    title: 'Ingest.',
    adminItems: [
      {
        icon: 'mdi-wrench',
        title: 'Admin',
        to: '/',
      },
    ],
    trialAdminItems: [
      {
        icon: 'mdi-wrench',
        title: 'Trial Admin',
        to: '/trial-admin',
      },
    ],
    nonAdminItems: [
      {
        icon: 'mdi-medical-bag',
        title: 'Your trials',
        to: '/trials',
      },
    ],
  }),
  computed: {
    items: (context) => {
      if (
        context.$auth &&
        context.$auth.user &&
        isAdminRole(context.$auth.user.role.toString())
      ) {
        return [...context.adminItems, ...context.nonAdminItems]
      } else if (
        context.$auth &&
        context.$auth.user &&
        isTrialAdminRole(context.$auth.user.role.toString())
      ) {
        return [...context.trialAdminItems, ...context.nonAdminItems]
      } else {
        return context.nonAdminItems
      }
    },
  },
  methods: {
    async reload() {
      window.location.reload()
    }
  }
}
</script>
